import {Box, Stack} from '@mui/material';
import {useParams} from 'react-router-dom';
import {MyRemindersScreen} from '../../professional-caregivers/my-reminders/my-reminders.screen';
import {PlannerSiderPanel} from '../calendar/side-panel/planner-sider-panel';

export function RemindersProfessionalCaregiverOfficeScreen() {
  const {entityId} = useParams<{entityId: string}>();

  return (
    <Stack direction="row">
      <PlannerSiderPanel entityId={entityId} remindersAvailable showReminders />
      <Box sx={{flex: 1, minWidth: 0}}>
        <MyRemindersScreen key={entityId} entityId={entityId} />
      </Box>
    </Stack>
  );
}
